// @ts-nocheck
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Button, Icon, Typography } from '@material-ui/core';
import { GridOverlay, GridToolbarContainer } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../../../common/components';
import { DateUtils } from '../../../../../../common/utils';
import { useDialog } from '../../../../../../common/hooks';
import ContractUsersForm from '../../../common/ContractUsersForm';

const useStyles = makeStyles(() => ({
  container: {
    flex: '1',
    height: '100%',
    minHeight: '500px',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
  dialog: {
    padding: '0',
    marginBottom: '0',
  },
  dialogContent: {
    display: 'flex',
    minWidth: '550px',
    maxWidth: '1200px',
    overflow: 'hidden',
  },
}));

function ContractUsersTab(props) {
  const [t] = useTranslation();
  const { showDialog } = useDialog();
  const classes = useStyles();

  const { contract, onAddUser, onActivateContract, onUpdateContractUsers, actionsDisabled } = props;
  const users = _.defaultTo(contract.subscriptions, []);

  const getColumnDefs = () => [
    {
      field: 'email',
      headerName: t('contract.contractUserEmail'),
      width: 350,
      flex: 1,
    },
    {
      field: 'status',
      headerName: t('contract.contractUserStatus'),
      width: 175,
      flex: 1,
    },
    {
      field: 'createdAt',
      headerName: t('contract.contractUserCreated'),
      width: 175,
      flex: 1,
      type: 'dateTime',
      valueFormatter: params => DateUtils.getDateTime(params.value),
    },
  ];

  const updateIds = rows => {
    let index = 1;
    return rows.map(row => {
      if (row.status === 'Afventer aktivering') {
        row.id = ++index;
      }
      return row;
    });
  };

  const getRowData = () => {
    if (contract.status === 'Ikke gennemført') {
      return updateIds(users);
    }
    return users;
  };

  const handleShowActivateDialog = () => {
    showDialog({
      title: t('common.important'),
      content: <Typography>{t('contract.contractActivateConfirm')}</Typography>,
      onConfirm: onActivateContract,
    });
  };

  const handleShowAddUsersDialog = () => {
    showDialog({
      title: t('contract.contractAddUsers'),
      content: params => (
        <Box className={classes.dialogContent}>
          <ContractUsersForm
            onSave={params.onConfirm}
            onCancel={params.onCancel}
            onAddUser={onAddUser}
            saveButtonText={t('contract.contractPersistUsers')}
            saveButtonIcon="task_alt"
            addedUsers={users}
          />
        </Box>
      ),
      onConfirm: onUpdateContractUsers,
      className: classes.dialog,
      throwOnError: true,
      hideFooter: true,
    });
  };

  const renderToolbar = () => (
    <GridToolbarContainer>
      {contract.subscriptions?.length > 0 ? (
        <Button
          id="ContractUsersTab-activate"
          variant="outlined"
          color="primary"
          startIcon={<Icon>toggle_on</Icon>}
          onClick={handleShowActivateDialog}
          disabled={actionsDisabled || contract.status === 'Aktiv'}
        >
          {t('contract.contractActivate')}
        </Button>
      ) : (
        ''
      )}
      <Button
        id="ContractUsersTab-addUsers"
        variant="outlined"
        color="primary"
        startIcon={<Icon>group_add</Icon>}
        onClick={handleShowAddUsersDialog}
        disabled={actionsDisabled || contract.status === 'Aktiv'}
      >
        {t('contract.contractAddUsers')}
      </Button>
    </GridToolbarContainer>
  );

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('contract.contractUsersEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="ContractUsersTab-container" className={classes.container}>
      <DataTable
        id="ContractUsersTab-table"
        components={{
          Toolbar: renderToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        pageSize={contract.subscriptions?.length}
        paginationMode="client"
        pagination
      />
    </Box>
  );
}

ContractUsersTab.propTypes = {
  contract: PropTypes.shape({
    id: PropTypes.number,
    companyId: PropTypes.number,
    productId: PropTypes.number,
    productName: PropTypes.string,
    customerAccount: PropTypes.string,
    invoiceAccount: PropTypes.string,
    duration: PropTypes.number,
    unitPrice: PropTypes.number,
    status: PropTypes.string,
    notes: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    expiredOn: PropTypes.string,
    renewAt: PropTypes.string,
    subscriptions: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onAddUser: PropTypes.func.isRequired,
  onActivateContract: PropTypes.func.isRequired,
  onUpdateContractUsers: PropTypes.func.isRequired,
  actionsDisabled: PropTypes.bool.isRequired,
};

export default ContractUsersTab;
